import styled from 'styled-components';
export var Module = styled.div.withConfig({
  displayName: "Module",
  componentId: "sc-1dpjbpx-0"
})(["margin-bottom:", ";", ";"], function (_ref) {
  var noMargin = _ref.noMargin;
  return !noMargin ? '80px' : '32px';
}, function (_ref2) {
  var _ref2$$noMargin = _ref2.$noMargin,
    $noMargin = _ref2$$noMargin === void 0 ? false : _ref2$$noMargin;
  return $noMargin && 'margin-bottom: 0px';
});